<template>
  <ul :class="$style.container">
    <li
      v-for="item in list" :key="item.name"
      :class="[$style.item, { [$style.itemDisabled]: item.disabled }]"
      @click="item.handler"
    >
      <BaseIcon :name="item.icon" :class="$style.icon" />
      <div>{{ item.name }}</div>
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'callout-menu',
  props: {
    callout: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      list: [
        {
          name: this.$t('callout.delete'),
          icon: 'trash-alt',
          handler: () => {
            this.$modal.show('confirm', {
              content: this.$t('callout.deleteConfirmation', { name: this.callout.payload.advertising.title }),
              onSubmit: async () => {
                await this.deleteMessage(this.callout.messageId)
                this.$router.push({ name: 'callouts' })
              }
            })
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      deleteMessage: 'entities/callouts/deleteMessage'
    })
  }
}
</script>

<style lang="scss" module>
.container {
  width: 100%;
  color: $text-darkest;
  padding: 6px 20px 6px 0;
}
.item {
  height: 42px;
  display: flex;
  font-size: 14px;
  align-items: center;
  cursor: pointer;
  &Disabled {
    color: $text-mid;
    cursor: default;
  }
  &:not(.itemDisabled):hover {
    color: $text-colored;
    .icon {
      color: $text-colored;
    }
  }
}
.icon {
  margin: 0 12px;
  color: $text-light;
  font-size: 16px;
}
</style>
